import axios from "axios";
import { domainKey } from "./globalUtility";

const endpoint = process.env.REACT_APP_API_ENDPOINT ?? "";
const apiEndPoint = '';

const axiosInstance = axios.create({
    baseURL: apiEndPoint,
    headers: {
      "Content-type": "application/json",
    },
});

// Update the domain key header based on the selected program on each request
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['domain-key'] = domainKey;
    return config;
  },
  (error) => Promise.reject(error)
);

export const getGoogleMapKey = async () => {
    return await executeGet("/api/apiKeys/google-maps-key");
};

export const getGoogleMapGeocodeKey = async () => {
    return await executeGet("/api/apiKeys/google-maps-geocode-key");
};

const executeGet = async (endpoint) => {
    try {
      const result = await axiosInstance.get(`${endpoint}`);
      return result?.data?.key;
    } catch(err) {
      return { success: false };
    }
};
